import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../../routes/urls';
import { resetPasswordDetail } from '../../../services/authServices';
import Button from '../../../component/button';
import { getUrlParam } from '../../../helpers/common';
import AppLogo from '../../../component/appLogo';
import { Content, FormBlock, Group, Icon, InputValue, Title, Form, Viewer, FormTextArea } from '../styles';
import LayoutWithoutNavbar from '../../../component/layoutWithoutNavbar';
import { BUTTON_TYPE } from '../../../global/constants';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

const ResetPassword: React.FC = () => {
  //State
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  //mobx variable
  const { appStore } = rootStore;
  const { authLoading } = appStore;

  //Other variable
  const location = useLocation();
  const history = useHistory();
  const userId: string | null = getUrlParam(location?.search, 'user_id');
  const token = getUrlParam(location?.search, 'token');

  // for password reset
  const onSubmitPassword = useCallback(
    async (e: React.SyntheticEvent) => {
      e.preventDefault();
      const payload = {
        // userId: userId,
        token: token,
        email: userId,
        password: password,
        confirmPassword: confirmPassword
      };
      const result = await resetPasswordDetail(payload);
      if (result) {
        history.push(ROUTES.LOGIN);
      }
    },
    [password, confirmPassword, history, userId, token]
  );

  return (
    <>
      <LayoutWithoutNavbar>
        <Group isResetPasswordPage={true} className='windows-onboarding-flow'>
          <Content>
            <Icon>
              <AppLogo height={60} />
            </Icon>
            <Title> Reset Password</Title>
            <>
              <Form onSubmit={onSubmitPassword}>
                <FormBlock>
                  <InputValue
                    type='email'
                    placeholder='Email ID'
                    value={userId || ''}
                    disabled={true}
                    isResetPasswordPage={true}
                  />
                  <InputValue
                    type='password'
                    placeholder='Password'
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    isResetPasswordPage={true}
                    className='password'
                  />
                  <InputValue
                    type='password'
                    placeholder='Confirm Password'
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                    }}
                    className='password-input'
                    isResetPasswordPage={true}
                  />
                </FormBlock>
                <Button title=' Save' variant={BUTTON_TYPE.PRIMARY} buttonType='submit' isLoading={authLoading} />
              </Form>
              <FormTextArea isResetPasswordPage={true}>
                <Viewer role='button' onClick={() => history.push(ROUTES.LOGIN)}>
                  Back to Login
                </Viewer>
              </FormTextArea>
            </>
          </Content>
        </Group>
      </LayoutWithoutNavbar>
    </>
  );
};

export default observer(ResetPassword);
